import type { AxiosRequestConfig } from 'axios';
import api from '@/lib/api';
import type { MonthlyPrice } from '@/api/types';

export interface CpuArchitectureDetails {
  value: string;
  short: string;
  description: string;
  order: number;
}

export interface ProductDatacenter {
  /** Optional frontend-only alias; backend currently exposes the code as `name`. */
  id?: string;
  name: string;
  city: string;
  country: string;
  /** Net monthly list price for this product in this datacenter; null/undefined when unavailable. */
  monthlyPrice?: MonthlyPrice | null;
}

export interface Product {
  productId: string;
  name: string;
  highlight: boolean;
  family: string;
  // This property now uses the new structured interface
  cpuArchitecture: CpuArchitectureDetails;
  cpus: number;
  memory: number;
  disk: number;
  provider: string;
  providerProductId: string;
  regions: string[];
  countries: string[];
  cities: string[];
  datacenters: ProductDatacenter[];
  supportedRegions: string[];
  supportedCountries: string[];
  supportedDatacenters: ProductDatacenter[];
}

export interface ProductsResponse {
  products: Product[];
}

/**
 * List GitLab products available for creating a runner.
 * Backend endpoint: GET /rest/product/gitlab
 */
export async function listProducts(config: AxiosRequestConfig = {}): Promise<Product[]> {
  const { data } = await api.get<ProductsResponse>('product/gitlab', config);
  return data.products || [];
}
